import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';



@Component({
  selector: 'printing2',
  templateUrl: './printing2.component.html',
  styleUrls: ['./printing2.component.scss']
})

export class  Printing2Component implements OnInit {
  
  @Input() hasimage: number;

  public Date: Date;

 
  constructor(private route: ActivatedRoute, private router: Router,) { }


  ngOnInit() {
    //alert('hasimage');
    this.Date = new Date();
  }
  

 
 
 


 
}
